export const createInvoiceReminder = (payload = {}) => {
  const invoice_reminder = payload.invoice_reminder || {};
  const invoice_reminder_contacts = payload.invoice_reminder_contacts || [];

  return {
    invoice_reminder,
    invoice_reminder_contacts,
  };
}